import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
// import {SUPER_ADMIN_EMAIL_REGEX} from '../../config/env'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const SectorPage = lazy(() => import('./pages/SectorPage'))
const SectorCreatePage = lazy(() => import('./pages/SectorCreatePage'))
const SectorEditPage = lazy(() => import('./pages/SectorEditPage'))

export const SECTOR_ROUTES: RouteObject[] = [
  {
    path: '/sectors',
    element: (
      <>
        <AppHelmet title='Sectors' />
        <AuthProtectedLayout adminOnly>
          <AppLayout>
            <PageSuspenseFallback>
              <SectorPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/sectors/create',
        element: (
          <>
            <AppHelmet title='Create sector' />
            <PageSuspenseFallback>
              <SectorCreatePage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/sectors/:sectorCode/edit',
        element: (
          <>
            <AppHelmet title='Edit sector' />
            <PageSuspenseFallback>
              <SectorEditPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
